const norm = (s) => (s || "").toString().toLowerCase();

export function customerFields(c) {
  return [c.name, c.firm_name, c.customer_code, c.phone, ...(c.vehicle_numbers || [])].filter(Boolean).map(norm);
}

// Rank: 0 = a word starts with query, 1 = any field contains query (spaces ignored), else no match
export function customerRank(c, q) {
  const s = norm(q).trim();
  if (!s) return 1;
  const fields = customerFields(c);
  const words = fields.flatMap((f) => f.split(/[\s,\-./]+/)).filter(Boolean);
  if (words.some((w) => w.startsWith(s.replace(/\s/g, "")))) return 0;
  const flat = s.replace(/\s/g, "");
  if (fields.some((f) => f.replace(/\s/g, "").includes(flat))) return 1;
  return -1;
}

export function searchCustomers(list, q, limit) {
  const s = norm(q).trim();
  if (!s) return limit ? [] : list || [];
  const out = (list || []).map((c) => [customerRank(c, s), c]).filter(([r]) => r >= 0).sort((a, b) => a[0] - b[0] || a[1].name.localeCompare(b[1].name)).map(([, c]) => c);
  return limit ? out.slice(0, limit) : out;
}
